<template>
  <div class="container-fluid">
    <!-- Title -->
    <div class="row flex-row justify-content-between">
      <div class="mb-4">
        <div class="text-head font-weight-bold h2 py-0 my-0 text-black">
          Cash flow report
        </div>
        <!-- <div @click="goBack">
            <span class="s-18 fw-400 cursor-pointer text-black">
              <img src="../../../assets/goback.png" alt="" /> Go back</span
            >
          </div> -->
      </div>
      <div class="c-pointer" v-if="selectedTab === 'summary'">
        <el-dropdown trigger="click" class="w-100">
          <div class="d-flex default-btn text-dark w-100" size="large">
            <span class="mt-1 s-14 text-head" style="color: #0040ff"
              >Export</span
            >
            <div class="mt-0 ml-1">
              <el-icon :size="10" class="el-icon--right primary--text"
                ><ArrowDownBold
              /></el-icon>
            </div>
          </div>
          <template #dropdown>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(bookType, index) in bookTypeList"
                :key="index"
              >
                <a
                  class="no-decoration text-dark"
                  @click="downloadFile(bookType)"
                >
                  {{ bookType.name }}
                </a>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <div class="row bg-gray-300 justify-content-center py-3 border-radius-8">
      <div class="col-md-12 pl-4">
        <div class="row align-items-center">
          <div class="col-md-8 col-12">
            <div class="row align-items-center">
              <div class="col-md-3 col-12">
                <div class="text-md-right text-left s-14 fw-400 text-dak">
                  Date Range
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="startDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
              <div class="col-md-3 col-12 px-0 mb-3 mb-md-0">
                <div class="col-12 px-md-1">
                  <el-date-picker
                    v-model="endDate"
                    type="date"
                    format="DD/MM/YYYY"
                    class="w-100 calendar"
                  />
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-4 col-12">
            <div
              class="col-md-12 mt-3 d-flex justify-content-center justify-content-md-end px-0"
            >
              <el-button
                class="c-pointer w-100"
                :color="primarycolor"
                :loading="loading"
                round
                @click="generateReport"
              >
                Generate Report
              </el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- Accounts Table -->
    <div class="row mt-4">
      <div class="col-md-12">
        <div class="text-center">
          <div class="row justify-content-center">
            <div
              class="col-md-10 d-flex justify-content-between align-items-end"
            >
              <div class="fw-400 s-14 text-dak">
                <span>Cash Inflow</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(totalInflows).toLocaleString() }}
                </div>
              </div>
              <span>-</span>
              <div class="fw-400 s-14 text-dak">
                <span>Cash Outflow</span>
                <div class="s-24 font-weight-600 text-head text-dak">
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(totalOutflows).toLocaleString() }}
                </div>
              </div>
              <span>=</span>
              <div class="fw-400 s-14 text-dak">
                <span>Net Balance</span>
                <div
                  v-if="totalOutflows && totalInflows"
                  :style="{
                    color: totalInflows - totalOutflows < 0 ? 'red' : '#088c35',
                  }"
                  class="s-24 text-head font-weight-600"
                >
                  {{ currentUser.currencySymbol }}
                  {{ Math.abs(totalInflows - totalOutflows).toLocaleString() }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- Tabs -->
        <div class="d-flex justify-content-center mt-5 cursor-pointer">
          <div
            style="background: #e0f2ff"
            class="p-1 d-flex align-items-center border-radius-8"
          >
            <div
              v-for="tab in tabs"
              :key="tab.id"
              style="color: #08162e"
              class="s-12 px-3"
              :class="{ active: selectedTab === tab.id }"
              @click="handleTabClick(tab.id)"
            >
              {{ tab.label }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="selectedTab === 'summary'">
      <div class="col-md-12 px-0">
        <CashFlowSummary
          :endDate="endDate"
          :startDate="startDate"
          :bookType="bookTypeItem"
          :fileHeaderToExport="fileHeaderToExport"
          :fileToExport="fileToExport"
          :fileName="fileName"
          :cashFlowSummaryData="cashFlowItem"
          @download-complete="handleDownloadComplete"
        />
      </div>
    </div>
    <div class="mt-3 row" v-if="selectedTab === 'details'">
      <div
        class="container-fluild table-main remove-styles2 remove-border responsiveness"
      >
        <table
          class="table remove-styles mt-0 table-hover table-header-area"
          id="table"
        >
          <thead class="table-header-ar">
            <tr class="font-weight-bold">
              <th>ACCOUNTS</th>
              <th class="text-right"></th>
              <th class="text-right text-dak s-14">
                {{ formatDate(startDate) }} <br />
                to {{ formatDate(endDate) }}
              </th>
            </tr>
          </thead>

          <!-- Opening Balance -->
          <!-- <tbody>
            <tr class="table-header-area-main">
              <td colspan="3" class="text-dak fw-400 s-14">
                Opening Balance: {{ currentUser.currencySymbol }}
                {{ formatAmount(openingBalance) }}
              </td>
            </tr>
          </tbody> -->

          <!-- Cash Flow Data Grouped by Category -->
          <tbody
            v-for="(category, categoryName, index) in groupedCashFlow"
            :key="categoryName"
          >
            <!-- Category Header -->
            <tr class="table-header-area-main">
              <td class="text-dak fw-400 s-14">{{ categoryName }}</td>
              <td class="text-right text-dak fw-400 s-14" v-if="index === 0">
                Inflows
              </td>
              <td class="text-right text-dak fw-400 s-14" v-if="index === 0">
                Outflows
              </td>
              <td v-if="index !== 0"></td>
              <td v-if="index !== 0"></td>
            </tr>

            <!-- Account Groups under this Category (indented) -->
            <tr v-for="(group, groupName) in category.groups" :key="groupName">
              <td class="text-blue-400 fw-500 s-14">{{ groupName }}</td>
              <td class="text-right">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(group.inflows) }}
              </td>
              <td class="text-right">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(group.outflows) }}
              </td>
            </tr>

            <!-- Category Total -->
            <tr class="table-header-area-mai">
              <td class="font-weight-bold">Total</td>
              <td class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(category.totalInflows) }}
              </td>
              <td class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(category.totalOutflows) }}
              </td>
            </tr>

            <!-- Category Net Balance -->
            <!-- <tr class="table-header-area-main">
              <td class="font-weight-bold">Net Balance</td>
              <td colspan="2" class="text-right font-weight-bold">
                {{ currentUser.currencySymbol }}
                {{ formatAmount(category.netCashFlow) }}
              </td>
            </tr> -->
          </tbody>

          <!-- Overall Net Balance -->
          <tr class="table-header-area-main">
            <td class="font-weight-bold">Net balance</td>
            <td colspan="2" class="text-right font-weight-bold">
              {{ currentUser.currencySymbol }}
              {{ formatAmount(netCashFlow) }}
            </td>
          </tr>

          <!-- Closing Balance -->
          <!-- <tr class="table-header-area-main">
            <td colspan="3" class="text-dak fw-400 s-14">
              Closing Balance: {{ currentUser.currencySymbol }}
              {{ formatAmount(closingBalance) }}
            </td>
          </tr> -->
        </table>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, ref, inject, nextTick } from "vue";
import axios from "@/gateway/backendapi";
import { useStore } from "vuex";
import CashFlowSummary from "./CashFlowSummary.vue";
// import exportService from "../../../services/exportFile/exportservice";
import exportService from "../../../services/exportFile/exportserjs";
import dateFormatter from "../../../services/dates/dateformatter";
import { ElNotification } from "element-plus";

// Date & Filters
const startDate = ref(new Date().setFullYear(new Date().getFullYear() - 1));
const endDate = ref(new Date(Date.now()));
const loading = ref(false);
const primarycolor = inject("primarycolor");
const fileHeaderToExport = ref([]);
const fileToExport = ref([]);

// const displayTitle = ref(false);
const cashFlowData = ref([]);
const cashFlowItem = ref({});
const openingBalance = ref("");
const fileName = ref("Cash Flow Report");
const store = useStore();
const bookTypeItem = ref("");
const bookTypeList = ref([
  { name: "xlsx" },
  { name: "csv" },
  { name: "txt" },
  { name: "pdf" },
]);
const selectedTab = ref("summary");

const tabs = [
  { id: "summary", label: "Summary" },
  { id: "details", label: "Details" },
];

const handleTabClick = async (tabId) => {
  selectedTab.value = tabId;
  if (tabId === "summary") {
    await getReport();
  }
};

const currentUser = computed(() => {
  if (store && Object.keys(store.getters.currentUser).length > 0)
    return store.getters.currentUser;
  return "";
});

const downloadFile = async (item) => {
  bookTypeItem.value = null;
  await nextTick();
  bookTypeItem.value = item.name;
};

// const downloadFile = async (item) => {
//   if (item.name === "pdf") {
//     displayTitle.value = true;
//     await nextTick();
//     exportService.downLoadExcel(
//       item.name,
//       document.getElementById("element-to-print"),
//       fileName.value,
//       fileHeaderToExport.value,
//       fileToExport.value
//     );
//   } else {
//     displayTitle.value = false;
//     exportService.downLoadExcel(
//       item.name,
//       document.getElementById("element-to-print"),
//       fileName.value,
//       fileHeaderToExport.value,
//       fileToExport.value
//     );
//   }
// };

const handleDownloadComplete = (success) => {
  if (success) {
    console.log("Export completed successfully");
    ElNotification.success({ message: "Export completed!" });
  } else {
    console.error("Export failed");
    ElNotification.error({ message: "Export failed!" });
  }
};

const generateReport = async () => {
  loading.value = true;
  try {
    await getReport();
  } catch (error) {
    console.error(error);
  } finally {
    loading.value = false;
  }
};

const getReport = async () => {
  try {
    const { data } = await axios.get(
      `/api/Reports/financials/getCashFlowReport?startDate=${new Date(
        startDate.value
      ).toLocaleDateString("en-US")}&endDate=${new Date(
        endDate.value
      ).toLocaleDateString("en-US")}`
    );

    cashFlowItem.value = data || [];
    cashFlowData.value = data.cashFlow || [];
    openingBalance.value = data.openingBalance || 0;

    // Prepare data for export
    setTimeout(() => {
      fileHeaderToExport.value = exportService.tableHeaderToJson(
        document.getElementsByTagName("th")
      );
      fileToExport.value = exportService.tableToJson(
        document.getElementById("table")
      );
    }, 1000);
  } catch (error) {
    console.error(error);
    ElNotification.error({
      title: "Error",
      message: "Failed to load cash flow report",
    });
  }
};

// Initial data load
getReport();

// Group cash flow data by category and account group
const groupedCashFlow = computed(() => {
  const groups = {};

  cashFlowData.value.forEach((item) => {
    const category = item.category || "Other";
    const accountGroup = item.accountGroupName || "Other";

    if (!groups[category]) {
      groups[category] = {
        groups: {},
        totalInflows: 0,
        totalOutflows: 0,
        netCashFlow: 0,
      };
    }

    if (!groups[category].groups[accountGroup]) {
      groups[category].groups[accountGroup] = {
        inflows: 0,
        outflows: 0,
      };
    }

    // Add values (outflows are stored as positive numbers for display)
    const inflow = item.inflows || 0;
    const outflow = Math.abs(item.outflows) || 0;

    groups[category].groups[accountGroup].inflows += inflow;
    groups[category].groups[accountGroup].outflows += outflow;

    groups[category].totalInflows += inflow;
    groups[category].totalOutflows += outflow;
    groups[category].netCashFlow =
      groups[category].totalInflows - groups[category].totalOutflows;
  });

  return groups;
});

// Calculate overall totals
const totalInflows = computed(() => {
  return Object.values(groupedCashFlow.value).reduce(
    (sum, category) => sum + category.totalInflows,
    0
  );
});

const totalOutflows = computed(() => {
  return Object.values(groupedCashFlow.value).reduce(
    (sum, category) => sum + category.totalOutflows,
    0
  );
});

const netCashFlow = computed(() => {
  return totalInflows.value - totalOutflows.value;
});

const closingBalance = computed(() => {
  return openingBalance.value + netCashFlow.value;
});
const formatDate = (date) => {
  return dateFormatter.monthDayYear(date);
};

// Format Amount (keep your existing formatAmount function)
const formatAmount = (amount) =>
  amount.toLocaleString("en-NG", { minimumFractionDigits: 2 });
// Format Amount
</script>

<style scoped>
.table th,
.table td {
  border-top: none;
}
.active {
  background: #ffffff;
  color: #08162e;
  font-weight: 700;
  height: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  /* padding: 15px 0; */
}
.bg-secondary {
  background-color: #f8f9fa !important;
}
button.el-button {
  height: 36px !important;
  width: 139px !important;
  padding: 13px 24px !important;
  font-size: 13px !important;
}
.table-main {
  width: 100% !important;
  box-shadow: 0 0.063rem 0.25rem #02172e45 !important;
  /* border: 0.063rem solid #dde2e6 !important; */
  /* border-radius: 30px !important; */
  text-align: left !important;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem !important;
}

.remove-styles {
  border: none !important;
  box-shadow: none !important;
  border-bottom: 0 !important;
  border-bottom-left-radius: 0 !important;
  border-bottom-right-radius: 0 !important;
}

.remove-styles2 {
  padding-right: 0;
  padding-left: 0;
  border-top-left-radius: 0 !important;
  border-top-right-radius: 0 !important;
}
table tbody tr,
table thead tr {
  border-bottom: 1px solid rgba(0, 0, 1, 0.2);
}
table tbody tr:first-child {
  border-bottom: none !important;
}
table tbody tr:last-child {
  border-bottom: none !important;
}

.remove-border {
  box-shadow: none !important;
}
.table {
  width: 100% !important;
  box-shadow: none !important;
  border: none !important;
  text-align: left;
  margin-bottom: auto !important;
  padding-bottom: 0.5rem;
}

.table thead th {
  font-weight: 700 !important;
  color: #000000 !important;
  font-size: 14px !important;
}
.table tbody tr {
  font-weight: 400 !important;
  color: #000000 !important;
  font-size: 14px !important;
}

.table-header-area-main {
  background-color: #d4dde4 !important;
  /* background-color: #f4f4f4; */
}

.table-header-area {
  border-top-left-radius: 0;
  border-top-right-radius: 0;
}
</style>
